import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import {
  setHasCookieConsent,
  setHasSavedCookieSettings,
} from 'app/dealer/cookieDashboard/actions';
import { Button } from 'app/shared/components/Button/Button';
import {
  MORE_DETAILS_HREF,
  MORE_DETAILS_LINK,
  COOKIE_DASHBOARD_HREF,
  COOKIE_DASHBOARD_LINK,
  HTML_FORMATTED_MESSAGE,
  HTML_FORMATTED_MESSAGE_ID,
} from 'app/shared/components/CookieBanner/constants';
import {
  CookieBannerContentSt,
  CookieBannerOverlaySt,
  CookieBannerContainerSt,
  CookieBannerTextWrapperSt,
  CookieBannerCallToActionSt,
  CookieBannerCallToActionItemSt,
} from 'app/shared/components/CookieBanner/CookieBanner.css';
import { isCrawler } from 'app/shared/utils/utils';
import { trackAction } from 'app/shared/utils/tracking';
import { useDispatch, useSelector } from 'react-redux';

const FormattedHTMLMessageHOC = (props) => {
  return <FormattedHTMLMessage {...props} />;
};

export const CookieBanner = ({ target }) => {
  const dispatch = useDispatch();
  const { hasSavedCookieSettings } = useSelector(
    ({ cookieDashboard }) => cookieDashboard
  );

  const hideBanner = hasSavedCookieSettings;

  useEffect(() => {
    window.document.body.style.overflow = 'hidden';
  }, []);

  useEffect(() => {
    if (hideBanner || isCrawler())
      window.document.body.style.overflow = 'scroll';
  }, [hideBanner]);

  const navigateToHref = (href) => {
    window.location.assign(href);
  };

  /* istanbul ignore next */ const catchAnchorClick = (event) => {
    event.preventDefault();
    const { id } = event.target;

    switch (id) {
      case MORE_DETAILS_LINK:
        trackAction('cookie_banner_copy_more_details_link_click', {
          category: target,
          description: 'user clicks on the more-details link in the copy',
        });

        navigateToHref(MORE_DETAILS_HREF);
        break;

      case COOKIE_DASHBOARD_LINK:
        trackAction('cookie_banner_copy_cookie_dashboard_link_click', {
          category: target,
          description: 'user clicks on the cookie dashboard link in the copy',
        });

        navigateToHref(COOKIE_DASHBOARD_HREF);
        break;
      default:
        return null;
    }
  };

  const acceptCookies = (event) => {
    trackAction('cookie_banner_accept_button_click', {
      category: target,
      description: 'user clicks on the cookie banner cta',
    });

    dispatch(setHasCookieConsent());
    dispatch(setHasSavedCookieSettings());
    event.stopPropagation();
  };

  const handleMoreDetailsClick = () => {
    trackAction('cookie_banner_cookie_dashboard_link_click', {
      category: target,
      description: 'user clicks on the more-details link',
    });

    navigateToHref(COOKIE_DASHBOARD_HREF);
  };

  const Content = () =>
    !hideBanner && (
      <>
        <CookieBannerOverlaySt />
        <CookieBannerContainerSt onClick={catchAnchorClick}>
          <CookieBannerContentSt>
            <CookieBannerTextWrapperSt>
              <FormattedHTMLMessageHOC
                id={HTML_FORMATTED_MESSAGE_ID}
                defaultMessage={HTML_FORMATTED_MESSAGE}
              />
            </CookieBannerTextWrapperSt>
            <CookieBannerCallToActionSt>
              <CookieBannerCallToActionItemSt>
                <a
                  href={COOKIE_DASHBOARD_HREF}
                  alt="Details anzeigen"
                  onClick={handleMoreDetailsClick}
                >
                  Details anzeigen
                </a>
              </CookieBannerCallToActionItemSt>
              <CookieBannerCallToActionItemSt>
                <Button
                  fullSize
                  onClick={acceptCookies}
                  dataQa="shared-components-cookieBanner-acceptBtn"
                >
                  <FormattedMessage
                    id="shared.components.CookieBanner.understandButton"
                    defaultMessage="Einverstanden"
                  />
                </Button>
              </CookieBannerCallToActionItemSt>
            </CookieBannerCallToActionSt>
          </CookieBannerContentSt>
        </CookieBannerContainerSt>
      </>
    );
  return hideBanner ? null : <Content />;
};

CookieBanner.propTypes = {
  target: PropTypes.string,
  pathname: PropTypes.string,
};

CookieBanner.defaultProps = {
  target: null,
  pathname: null,
};
